<template>
  <div class="data-pills">
    <span class="status" :class="isActive ? 'status-green' : 'status-red'">
      <span class="status-dot" :class="isActive ? 'status-dot-animated' : ''"></span>
      {{ isActive ? $t('common.active') : $t('common.inactive') }}
    </span>
    <StatsPill
      v-if="locationText"
      :text="locationText"
      :icon="IconMapPin"
      class="pill-truncate"
      v-tooltip="locationText" />
    <StatsPill v-if="props.job.language" :text="props.job.language.toUpperCase()" :icon="IconLanguage" />
    <StatsPill v-if="workloadText" :text="workloadText" :icon="IconPercentage" />
    <StatsPill
      v-if="fieldOfActivity"
      :text="fieldOfActivity"
      :icon="IconBriefcase"
      class="pill-truncate"
      v-tooltip="fieldOfActivity" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { IconMapPin, IconLanguage, IconPercentage, IconBriefcase } from '@tabler/icons-vue';
import StatsPill from '@/components/generic/StatsPill.vue';
import type { ExternalJobMarketJob } from '@/types/externalJobMarket';

const props = defineProps<{ job: ExternalJobMarketJob }>();

const isActive = computed(() => props.job.active && (!props.job.expires || new Date(props.job.expires) > new Date()));

const locationText = computed(() => props.job.workplace_location || props.job.workplace_city || '');

const workloadText = computed(() => {
  if (props.job.workload_min != null && props.job.workload_max != null) {
    return `${props.job.workload_min}%–${props.job.workload_max}%`;
  }
  const pensum = props.job.properties?.ohws_attr_pensum;
  if (pensum) return String(pensum);
  if (props.job.workload_fulltime) return '100%';
  return '';
});

const fieldOfActivity = computed(() => {
  const foa = props.job.properties?.ohws_attr_field_of_activity;
  if (!foa || typeof foa !== 'object') return '';
  const values = Object.values(foa);
  return values.length > 0 ? String(values[0]) : '';
});
</script>

<style scoped>
.data-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  max-width: max-content;
  align-items: center;
}

.pill-truncate {
  max-width: 180px;
}
</style>
